import { TableauFallback, SansSerifFallback } from '../FormattingConverterConstants';
import { compareStrings, startsWithString } from './TypeUtil';

export class TextFontUtil {
  /**
   * Takes a list of current font families, and adds 'Arial' if any variation of the Tableau font is used.
   *
   * Arial will only be added to the end if it is not currently at the end of the fallbacks, so it is
   * possible to have Arial listed twice, but this algorithm will not add it multiple times. This is done
   * to save checking the entire list to determine if Arial is somewhere in the list, since Arial is
   * normally our fallback and should always be at the end, and functionally having it twice in the browser
   * is not an issue.
   * @param fontFamilies List of current fallbacks.
   */
  static addDefaultFontForTableau(fontFamilies: string[]): void {
    const tableauName = 'tableau';
    let needsFallback = false;
    const length = fontFamilies.length;
    for (let i = 0; i < length; i++) {
      // At this point it will be assumed that each name is well-formed, and will either have no quotes,
      // single quotes around the name, double quotes around the name, or both, but will not have mismatches.
      // This will allow using simple substrings to remove any leading quotes to get to the first name of the
      // font, which will be more performant than a replace and should be more performant than a regex.
      let currentFont = fontFamilies[i].trim();
      for (let j = 0; j < 2; j++) {
        if (startsWithString(currentFont, "'") || startsWithString(currentFont, '"')) {
          currentFont = currentFont.substr(1);
        }
      }

      if (compareStrings(currentFont.substr(0, tableauName.length), tableauName, true) === 0) {
        // Some from of Tableau found, so flag that we should add the fallback font(s) and exit this loop.
        needsFallback = true;
        break;
      }
    }

    if (needsFallback) {
      // Add both the fallback and sans-serif as the final backup if it is not currently there.
      fontFamilies.push(TableauFallback);
      fontFamilies.push(SansSerifFallback);
    }
  }
}
